import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

export default function PaymentSuccess() {
  const [message, setMessage] = useState('Verifica del tuo pagamento...');
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const sessionId = params.get('session_id');

    if (!sessionId) {
      setMessage('Nessuna sessione di pagamento trovata.');
      return;
    }

    axios.post(
      'https://api.cafpraticheonline.it/api/stripe/verify-payment',
      { sessionId }
    )
    .then(res => {
      setMessage(res.data.message || 'Pagamento verificato con successo!');
    })
    .catch(err => {
      console.error('Verifica non riuscita:', err?.response?.data || err.message);
      setMessage('Verifica del pagamento non riuscita.');
    });
  }, []);

  return (
    <div style={{ 
      textAlign: 'center', 
      padding: '2rem',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '60vh'
    }}>
      <h1 style={{ marginBottom: '2rem' }}>{message}</h1>
      <button
        onClick={() => navigate('/')}
        style={{
          background: 'linear-gradient(135deg, #F2C231, #C69A32)',
          color: '#000',
          fontWeight: '600',
          padding: '0.75rem 2rem',
          borderRadius: '0.375rem',
          border: 'none',
          cursor: 'pointer',
          fontSize: '1rem',
          boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
          transition: 'transform 0.2s, box-shadow 0.2s'
        }}
        onMouseOver={(e) => {
          e.target.style.transform = 'translateY(-2px)';
          e.target.style.boxShadow = '0 6px 8px rgba(0, 0, 0, 0.15)';
        }}
        onMouseOut={(e) => {
          e.target.style.transform = 'translateY(0)';
          e.target.style.boxShadow = '0 4px 6px rgba(0, 0, 0, 0.1)';
        }}
      >
        TORNA ALLA HOME
      </button>
    </div>
  );
}